var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import AdminPageLayout from '../../../layout/admin-page-layout';
import { useFetch } from '@rad/hooks';
import Input from '@rad/components/inputs/input';
import Modal from '@rad/components/ui/modal';
import createTable from '@rad/components/ui/table';
import { expand } from '@rad/utility/validation';
import { getDirectorTypes, createDirectorType, updateDirectorType } from '../../../common/network/director-type';
import { createDirectorTypeForm } from '../../../types/director';
import { useToast } from '../../../contexts/toast';
const DirectorTypes = () => {
    const toast = useToast();
    const [typesPromise, reloadTypes] = useFetch(getDirectorTypes());
    const [showModal, setShowModal] = React.useState(false);
    const [editingName, setEditingName] = React.useState(null);
    const [form, setForm] = React.useState(createDirectorTypeForm());
    const [errors, setErrors] = React.useState({});
    //const [showDeleteModal, setShowDeleteModal] = React.useState(false)
    //const [deletingName, setDeletingName] = React.useState<string | null>(null)
    const TypesTable = React.useMemo(() => createTable(typesPromise), [typesPromise]);
    const handleAdd = () => {
        setEditingName(null);
        setForm(createDirectorTypeForm());
        setErrors({});
        setShowModal(true);
    };
    const handleEdit = (type) => {
        setEditingName(type.name);
        setForm(Object.assign({}, type));
        setErrors({});
        setShowModal(true);
    };
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        setErrors({});
        const [success, err] = editingName
            ? yield updateDirectorType(editingName, Object.assign({}, form))
            : yield createDirectorType(form);
        if (success) {
            setShowModal(false);
            reloadTypes();
            toast.success(editingName ? 'Director type updated' : 'Director type created');
        }
        else {
            const [, expanded] = expand(err);
            setErrors(expanded);
            toast.error('Please fix the errors below');
        }
    });
    // const handleDeleteClick = (name: string) => {
    //   setDeletingName(name)
    //   setShowDeleteModal(true)
    // }
    // const handleDeleteConfirm = async () => {
    //   if (!deletingName) return
    //   const [success, err] = await deleteDirectorType(deletingName)
    //   if (success) {
    //     setShowDeleteModal(false)
    //     setDeletingName(null)
    //     reloadTypes()
    //     toast.success('Director type deleted')
    //   } else {
    //     setShowDeleteModal(false)
    //     setDeletingName(null)
    //     toast.error(err?.form || 'Failed to delete director type')
    //   }
    // }
    return (_jsx(AdminPageLayout, { children: _jsxs("div", { className: "container py-4", children: [_jsx("h5", { className: "fw-semibold mb-3", children: "Director Types" }), _jsx("div", { className: "d-flex justify-content-between align-items-center mb-4", children: _jsxs("button", { className: "btn btn-primary", onClick: handleAdd, children: [_jsx("i", { className: "bi bi-plus-lg me-2" }), "Add Director Type"] }) }), _jsxs(TypesTable, { className: "mb-0", children: [_jsx(TypesTable.Column, { header: "Display", accessor: "display" }), _jsx(TypesTable.Column, { header: "Sort Order", accessor: "sortOrder" }), _jsx(TypesTable.Column, { header: "", className: "text-end", render: type => (_jsx(_Fragment, { children: _jsx("button", { className: "btn btn-link text-primary p-0 me-2", onClick: () => handleEdit(type), title: "Edit", children: _jsx("i", { className: "bi bi-pencil" }) }) })) })] }), _jsx(Modal, { isOpen: showModal, title: editingName ? 'Edit Director Type' : 'Add Director Type', onClose: () => setShowModal(false), onSave: handleSave, children: _jsxs("div", { className: "d-flex flex-column gap-3", children: [!editingName && _jsx(Input, { kind: "text", label: "Name", value: form.name, onChange: v => setForm(Object.assign(Object.assign({}, form), { name: v })), invalid: errors.name }), _jsx(Input, { kind: "text", label: "Display", value: form.display, onChange: v => setForm(Object.assign(Object.assign({}, form), { display: v })), invalid: errors.display }), _jsx(Input, { kind: "number", label: "Sort Order", value: form.sortOrder, onChange: v => setForm(Object.assign(Object.assign({}, form), { sortOrder: v !== null && v !== void 0 ? v : 0 })), invalid: errors.sortOrder }), errors.form && _jsx("div", { className: "alert alert-danger", children: errors.form.join(', ') })] }) })] }) }));
};
export default DirectorTypes;
